import { useCallback, useEffect, useRef, useState } from "react";

import { api } from "api/loginRoutes";

const useAccountNotesPreview = (accountId, delay = 500) => {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const timerRef = useRef(null);
    const requestIdRef = useRef(0);

    const close = useCallback(() => {
        clearTimeout(timerRef.current);
        timerRef.current = null;
        requestIdRef.current += 1;
        setLoading(false);
    }, []);

    const open = useCallback(() => {
        clearTimeout(timerRef.current);

        const requestId = requestIdRef.current + 1;
        requestIdRef.current = requestId;
        setComments([]);
        setError(false);
        setLoading(true);

        timerRef.current = setTimeout(async () => {
            try {
                const response = await api("account_note:get_short_list", {
                    target: { account_id: accountId }
                });

                if (requestId !== requestIdRef.current) {
                    return;
                }

                if (Array.isArray(response?.account_note_list)) {
                    setComments(response.account_note_list);
                } else {
                    setError(true);
                }
            } catch (requestError) {
                if (requestId === requestIdRef.current) {
                    setError(true);
                }
            } finally {
                if (requestId === requestIdRef.current) {
                    setLoading(false);
                }
            }
        }, delay);
    }, [accountId, delay]);

    useEffect(() => () => {
        clearTimeout(timerRef.current);
        requestIdRef.current += 1;
    }, []);

    return {
        comments,
        loading,
        error,
        open,
        close
    };
};

export default useAccountNotesPreview;
